import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAccounts } from "@/api/accounts";
import { useAuth } from "@/context/AuthContext";

/**
 * Todo mundo navega pelo app inteiro, mas só assinante grava dado. `guard` embrulha o clique que
 * abriria um formulário/confirmação (anotar, editar, excluir): o visitante sem conta, que está
 * vendo a demonstração, é levado pro cadastro; quem tem conta mas não assinou, pra tela de
 * pagamento. O servidor barra a gravação do mesmo jeito - isso aqui só evita a pessoa preencher
 * um formulário à toa.
 */
export function usePaywall() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isGuest = !user;
  const isPremium = !!user?.isPremium;

  const guard = useCallback(
    (action: () => void) => {
      if (isGuest) navigate("/cadastro");
      else if (!isPremium) navigate("/premium");
      else action();
    },
    [isGuest, isPremium, navigate]
  );

  return { isGuest, isPremium, guard };
}

/**
 * Porta de entrada do "novo lançamento". Além do paywall, cobre quem acabou de assinar e
 * ainda não cadastrou nenhuma conta: sem conta não dá pra lançar nada, então vai pro
 * onboarding primeiro (antes da assinatura o onboarding não acontece, porque criar conta
 * também é gravar dado).
 */
export function useQuickAddGuard() {
  const { guard } = usePaywall();
  const navigate = useNavigate();
  const { data: accounts } = useAccounts();

  return useCallback(
    (open: () => void) =>
      guard(() => {
        if (accounts?.length === 0) navigate("/onboarding");
        else open();
      }),
    [guard, accounts, navigate]
  );
}
